export type ReleaseCardVariant = "compact" | "full" | "index" | "showcase";

export function releaseCardVariantModel(variant: ReleaseCardVariant) {
  const index = variant === "index";
  const showcase = variant === "showcase" || index;
  const titleClass = index
    ? "font-bold text-sm line-clamp-2 md:text-base"
    : showcase
      ? "font-bold text-base line-clamp-2"
      : variant === "compact"
        ? "font-bold text-sm truncate"
        : "font-bold truncate";
  return {
    index,
    showcase,
    titleClass,
    coverSize: variant === "compact" ? "size-14 shrink-0" : "size-24 md:size-28 shrink-0",
    extended: variant !== "compact",
  };
}
